import {Tool} from '@app/tool/model/tool.model';
import {OperationType} from '@app/tool/model/operationType.model';
import {TicketOperation} from "@models/ticket-operation.model";
import {User} from "@models/user.model";

import {GroupChildWrapper} from "@app/tool/model/group-child-wrapper.model";
import {Group} from "@app/tool/model/group.model";
import {TicketType} from "@models/enums/ticket-type.enum";
import {TicketToolReport} from "@models/ticket-tool-report.model";
import { TicketEvent } from './ticketHold.model';

export class Ticket {

    public id: number;
    public description: string;
    public createdDate: string;
    public startDate: string;
    public endDate: string;
    public deadLine: string;
    public currentOperation: TicketOperation;
    public status: string;
    public createdBy: any;
    public createdById: number;
    public assignedTo: User;
    public assignedToId: number;
    public issue: string;
    public issueId: number;
    public ticketTools: Tool[];
    public operationTypes: OperationType[];
    public isAutomatic: boolean;
    public hasPriority: boolean;
    public ticketOperations: TicketOperation[];
    public canBeClosed: boolean;
    public hasMaintenanceAtLine: boolean;
    public type: TicketType;
    public lineToolRequestId: number;
    public lineId: number;
    public line: any;
    public mainLines: string;
    public infoFromLine: string;
    public ticketReport: TicketToolReport;
    public ticketEvents: any;

    constructor(ticket: any = {}) {
        this.id = ticket.id || 0;
        this.description = ticket.description || '';
        this.createdDate = ticket.createdDate || '';
        this.startDate = ticket.startDate || '';
        this.endDate = ticket.endDate || '';
        this.deadLine = ticket.deadLine || '';
        this.currentOperation = new TicketOperation(ticket.currentOperation);
        this.status = ticket.status || '';
        this.createdBy = ticket.createdBy || {};
        this.createdById = ticket.createdById || 0;
        this.assignedTo = new User(ticket.assignedTo);
        this.assignedToId = ticket.assignedToId || 0;
        this.issue = ticket.issue || '';
        this.issueId = ticket.issueId || 0;
        this.ticketTools = this.mapGroupableItems(ticket.ticketTools);
        this.operationTypes = this.mapOperationTypes(ticket.operationTypes);
        this.isAutomatic = ticket.isAutomatic || false;
        this.hasPriority = ticket.hasPriority || false;
        this.ticketOperations = this.mapTicketOperations(ticket.ticketOperations);
        this.canBeClosed = ticket.canBeClosed;
        this.hasMaintenanceAtLine = ticket.hasMaintenanceAtLine || false;
        this.type = ticket.type || 0;
        this.lineToolRequestId = ticket.lineToolRequestId || 0;
        this.lineId = ticket.lineId;
        this.mainLines = ticket.mainLines || '';
        this.line = ticket.line || {};
        this.infoFromLine = ticket.infoFromLine;
        this.ticketReport = this.mapTicketToolReport(ticket.ticketReport);
        this.ticketEvents = this.mapTicketEvents(ticket.ticketEvents);
    }

    mapGroupableItems(items) {
        if (items) {
            const groups = items.items.map(group => {
                if (group.subGroup) {
                    return new Group(group);
                }
                return new GroupChildWrapper(group).item;
            });
            return groups;
        }
        return [];
    }


    mapOperationTypes(operationTypes = []) {
        return operationTypes.map(opType => new OperationType(opType));
    }

    mapTicketOperations(ticketOperations = []) {
        return ticketOperations.map(ticketOp => new TicketOperation(ticketOp));
    }

    mapTicketEvents(ticketEvents = []) {
        return ticketEvents.map(ticketEvent => new TicketEvent(ticketEvent));
    }

    mapTicketToolReport(ticketReport: TicketToolReport) {
        if (ticketReport) {
            return new TicketToolReport(ticketReport);
        }
        return null;
    }

    get createdByName() {
        return `${this.createdBy.firstName} ${this.createdBy.lastName}`
    }

    static get type() {
        return 'ticket';
    }
}
